<template>
  <app-base-main>
    <template #operate-group>
      <span class="icon-back" @click="goBack"><gj-icon iconfont="iconback"></gj-icon>&nbsp;返回</span>
      <span class="base-text">|</span>
      <span class="nav-tips"><span class="icon-back" @click="goBack">发货计划&nbsp;</span><i class="el-icon-arrow-right"></i>
        <span class="tips-to">&nbsp;详情</span>
      </span>
    </template>
    <template #base-content>
      <div class="content-cell">
        <div class="header">
          <div>
            详情（{{ row.code }}）
            <gj-tag type="plain" style="margin-right: 10px" shape="rectangle"
                    :color="row.status | optionColor(statusOption.open)">{{
                row.status | optionText(statusOption.open)
              }}
            </gj-tag>
          </div>
        </div>
        <div class="header-content_group">
          <div class="header-content">
            <div class="header-content__item">
              <span class="label">创建批次：</span>
              <span class="value">{{ shipPlanDetail.planBatchCode | defaultShow }}</span>
            </div>
            <div class="header-content__item">
              <span class="label">店铺/国家：</span>
              <span class="value" v-cloak>{{ shipPlanDetail.marketName | defaultShow }}:{{
                  shipPlanDetail.countryCode | defaultShow
                }}</span>
            </div>
            <div class="header-content__item">
              <span class="label">发货时间：</span>
              <span class="value">{{ shipPlanDetail.shipTime | defaultShow }}</span>
            </div>
          </div>
          <div class="header-content">
            <div class="header-content__item">
              <span class="label">包装类型：</span>
              <span class="value" v-cloak>{{ shipPlanDetail.areCasesRequired ? '原厂包装' : '混装' }}</span>
            </div>
            <div class="header-content__item">
              <span class="label">FBA货件号：</span>
              <span class="value">
                <span v-if="shipPlanDetail.shipPlanShipments && shipPlanDetail.shipPlanShipments.length > 0">
                  <el-dropdown>
                    <span class="el-dropdown-link" style="font-size: 12px">
                      <span>{{ shipPlanDetail.shipPlanShipments[0] | defaultShow }} <i
                          class="el-icon-arrow-down el-icon--right"
                          v-if="shipPlanDetail.shipPlanShipments.length > 1"></i></span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <template v-if="shipPlanDetail.shipPlanShipments.length > 1">
                        <template v-for="(item,key) in shipPlanDetail.shipPlanShipments">
                          <el-dropdown-item :key="key">
                            <span style="font-size: 12px">{{ item }}</span>
                          </el-dropdown-item>
                        </template>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
                </span>
                <span v-else>-</span>
              </span>
            </div>
            <div class="header-content__item">
              <span class="label">调拨单号：</span>
              <span class="value">
                <span v-if="shipPlanDetail.shipPlanTransfers && shipPlanDetail.shipPlanTransfers.length > 0">
                <el-dropdown>
                    <span class="el-dropdown-link" style="font-size: 12px">
                      <span>{{
                          shipPlanDetail.shipPlanTransfers[0] && shipPlanDetail.shipPlanTransfers[0].transferCode | defaultShow
                        }}
                        <i class="el-icon-arrow-down el-icon--right"
                          v-if="shipPlanDetail.shipPlanTransfers.length > 1"></i></span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <template v-if="shipPlanDetail.shipPlanTransfers.length > 1">
                        <template v-for="(item,key) in shipPlanDetail.shipPlanTransfers">
                          <el-dropdown-item :key="key">
                            <span style="font-size: 12px">{{ item.transferCode }}</span>
                          </el-dropdown-item>
                        </template>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
              </span>
                <span v-else>-</span>
              </span>
            </div>
          </div>
        </div>
        <div style="display: flex;justify-content: space-between;height: 40px;margin-top: 20px">
          <gj-area-title>发货商品</gj-area-title>
          <div style="display: flex">
            <gj-button type="text" style="margin-right: 20px" @click="openLog(row.id)">操作日志</gj-button>
            <gj-tool-group :sort-gjtable="$refs.gjTable" setting :table-name="tableName" :table-columns="columns"></gj-tool-group>
          </div>
        </div>
        <gj-table
            ref="gjTable"
            name="transferProductAddModal"
            :index="false"
            :loading="loading"
            :data="tableData"
            :columns="columns"
            :offset-height="80"
            @sort-change="$gjSortChange"
        >
          <template v-slot:msku="{row}">
            <div>
              <gj-text width="90%">{{ row.msku | defaultShow }}</gj-text>
            </div>
            <div>
              <gj-text width="90%">{{ row.fnsku | defaultShow }}</gj-text>
            </div>
          </template>
          <template v-slot:productName="{ row }">
            <div>
              <gj-text width="90%">{{ row.productName | defaultShow }}</gj-text>
            </div>
            <div>
              {{ row.sku | defaultShow }}
            </div>
          </template>
          <template v-slot:availableQuantity="{ row }">
            <div style="display: flex;justify-content: center">
              <span>
                  {{ row.availableQuantity | defaultShow }};&nbsp;{{ row.alreadyOrderQuantity | defaultShow }};
              &nbsp;{{ row.planWarehouseQuantity | defaultShow }}
              </span>
              <gj-popover trigger="hover" placement="bottom" width="600"
                          v-if="row.productType=== 'Assembly' && row.warehouseId">
                <template>
                  <div>
                    <div class="maxNum">
                      <div>最大装配量：<span style="color: #EFA621;">{{ maxTableDataVo.maxAssemblyQuantity }}</span></div>
                    </div>
                    <gj-table
                        :columns="maxNumColumns"
                        ref="gjTable2"
                        :index="false"
                        name="maxNumTable"
                        :data="maxTableDataVo.voList"
                        :loading="maxLoading"
                        :size="'has-picture'"
                        
                    >
                      <template v-slot:skuName="{row}">
                        <gj-text width="90%">{{ row.productName }}</gj-text>
                        <br>
                        <gj-text width="90%">{{ row.sku }}</gj-text>
                        <br>
                      </template>
                    </gj-table>
                  </div>
                </template>
                <div slot="reference" style="margin-left: 5px;color: #1F6EEF;">
                  <i class="el-icon-connection" @mouseover="getMaxNums(row.sku, row.warehouseId)"></i>
                </div>
              </gj-popover>
            </div>
          </template>
          <template v-slot:packageSize="{ row }">
            {{ row.packageL | defaultShow }} * {{ row.packageW | defaultShow }} * {{ row.packageH | defaultShow }}
          </template>
          <template v-slot:cartonSize="{ row }">
            {{ row.cartonSizeL | defaultShow }} * {{ row.cartonSizeW | defaultShow }} * {{
              row.cartonSizeH | defaultShow
            }}
          </template>
          <template v-slot:arriveCost="{ row }">
            ￥ {{ row.arriveCost | defaultShow }}
          </template>
          <template v-slot:purchaseCost="{ row }">
            ￥ {{ row.purchaseCost | defaultShow }}
          </template>
          <template v-slot:totalValue="{ row }">
            ￥ {{ row.totalValue  | defaultShow }}
          </template>
          <template v-slot:shipPlanShipments="{ row }">
            <span v-if="row.shipPlanShipments && row.shipPlanShipments.length > 0">
              <el-dropdown>
                  <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{
                        shipPlanDetail.shipPlanShipments[0].shipmentId + ' | ' + shipPlanDetail.shipPlanShipments[0].quantity
                      }}
                      <i class="el-icon-arrow-down el-icon--right"
                         v-if="shipPlanDetail.shipPlanShipments.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="shipPlanDetail.shipPlanShipments.length > 1">
                      <template v-for="(item,key) in shipPlanDetail.shipPlanShipments">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">{{ item.shipmentId + " | " + item.quantity }}</span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                 </el-dropdown>
             </span>
            <span v-else>-</span>
          </template>
          <template v-slot:shipPlanTransfers="{ row }">
             <span v-if="row.shipPlanTransfers && row.shipPlanTransfers.length > 0">
               <span v-if="shipPlanDetail.shipPlanTransfers && shipPlanDetail.shipPlanTransfers.length > 0">
                 <el-dropdown>
                  <span class="el-dropdown-link" style="font-size: 12px">
                    <span>{{
                        shipPlanDetail.shipPlanTransfers[0].transferCode + ' | ' + shipPlanDetail.shipPlanTransfers[0].quantity
                      }}
                      <i class="el-icon-arrow-down el-icon--right"
                         v-if="shipPlanDetail.shipPlanTransfers.length > 1"></i></span>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <template v-if="shipPlanDetail.shipPlanTransfers.length > 1">
                      <template v-for="(item,key) in shipPlanDetail.shipPlanTransfers">
                        <el-dropdown-item :key="key">
                          <span style="font-size: 12px">{{ item.transferCode + " | " + item.quantity }}</span>
                        </el-dropdown-item>
                      </template>
                    </template>
                  </el-dropdown-menu>
                 </el-dropdown>
               </span>
             </span>
            <span v-else>-</span>
          </template>
          <template v-slot:memo="{row}">
            <gj-text width="90%">{{ row.memo }}</gj-text>
          </template>
          <template #footer>
            <div class="table-footer">
              <span style="margin-right: 20px">产品总数：{{ tableData.length }}</span>
              <span style="margin-right: 20px">总箱数：{{ shipPlanDetail.packageQuantity | defaultShow }}</span>
              <span style="margin-right: 20px">总计划发货量：{{ shipPlanDetail.shipedPlanQuantity | defaultShow }}</span>
              <span style="margin-right: 20px">总货值（预估）：{{ shipPlanDetail.totalValue  | defaultShow }}</span>
            </div>
          </template>
        </gj-table>
        <div style="text-align: center;padding: 10px 10px 0 10px;">
          <gj-button :loading="btnLoading.generatePurchasePlan" @click="addPurchasePlan"
                     v-if="$permission('shipPlan:generatePurchasePlan') && StatusEnum.WAIT_HANDLE === row.status">生成采购计划
          </gj-button>
          <gj-button  @click="addTransferSlip" :loading="btnLoading.generateTransfer"
                     v-if="$permission('shipPlan:generateTransfer') && StatusEnum.WAIT_HANDLE === row.status">生成调拨单
          </gj-button>
          <gj-button  @click="addPackage" :loading="btnLoading.generateShipment"
                     v-if="$permission('shipPlan:generateShipment') && StatusEnum.WAIT_HANDLE === row.status">创建货件
          </gj-button>
          <gj-button v-if="$permission('shipPlan:printLabels')" @click="printLabel">打印商品标签</gj-button>
        </div>
      </div>
    </template>
  </app-base-main>
</template>

<script>
import {
  getDeliveryMaxAssemblyQuantity,
  getShipPlanQueryDetail,
  postShipPlanPurchasePlanQuery,
  postShipPlanGenerateShipment,
  postShipPlanGenerateTransfer,
} from '@/api/logistics'
import {queryMixin, selectionMixin} from "@/minxins";
import {mapGetters} from "vuex";
import {statusOption, operateOptions, statusEnum as StatusEnum} from '../deliveryEnum'
import AppOpTransferOrderModal from "@/views/modules/warehouse/transfer-order/modal/op/op-transfer-order-modal";
import {OpEnum} from "@/utils/options";
import AddFbaShipmentModal from "@/views/modules/common/logistics/fba-shipment/modal/add/add-fba-shipment-modal";
import GjLogModal from "@/components/modal/gj-log-modal";
import {isMeaningful} from "@/utils/common";
import AppPrintLabelModal from "@/views/modules/logistics/fba-shipment/modal/print-label-modal";
import {queryReviewSetting} from "@/api/purchase";
import OpPurchasePlanAddForDelivery from "@/views/modules/purchase/purchase-plan/modal/op-purchase-plan-add-for-delivery";

export default {
  name: "delivery-plan-detail",
  mixins: [queryMixin, selectionMixin],
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      tableName: 'ShipPlanDetail',
      shipPlanDetail: {},
      tableData: [],
      propRows: [],
      statusOption,
      reviewOption: false,
      purchaseVisible: false,
      operateOptions,
      StatusEnum,
      opTypePurchase: 0,
      maxTableDataVo: {
        maxAssemblyQuantity: null,
        voList: []
      },
      btnLoading: {
        generateShipment: false,
        generateTransfer: false,
        generatePurchasePlan: false,
      },
      maxLoading:false,
      maxNumColumns: [
        {id: "picture", header: "图片", field: "picture:imageUrl", width: "50px", align: 'center', default: true,},
        {id: "skuName", header: "产品名称/SKU", field: "slot:skuName", minWidth: "160px", default: true,},
        {id: "requiredAmountPerUnit", header: "单位所需量", field: "requiredAmountPerUnit", width: "100px", default: true,},
        {id: "availableQuantity", header: "可用量", field: "availableQuantity", width: "90px", default: true,},
        {id: "alreadyOrderQuantity", header: "已下单", field: "alreadyOrderQuantity", width: "90px", default: true,},
        {id: "planWarehouseQuantity", header: "计划入库", field: "planWarehouseQuantity", width: "90px", default: true,},
      ],
      columns: [
        {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px', default: true},
        {id: 'msku', header: 'MSKU/FNSKU', field: 'slot:msku', width: '140px', default: true},
        {id: 'productName', header: '产品名称/SKU', field: 'slot:productName', minWidth: '120px', default: true},
        {id: 'transportShow', header: '物流方式', field: 'transportShow', minWidth: '100px', default: true},
        {id: 'warehouseName', header: '发货仓库', field: 'warehouseName', minWidth: '100px', default: true},
        {id: 'shipedPlanQuantity', header: '计划发货量', field: 'shipedPlanQuantity', minWidth: '100px', default: true},
        {
          id: 'availableQuantity',
          header: '可用量/已下单/计划入库',
          field: 'slot:availableQuantity',
          minWidth: '180px',
          default: true
        },
        {id: 'difference', header: '差额', field: 'difference', minWidth: '60px', default: true},
        {
          id: 'areCasesRequired',
          header: '包装类型',
          field: 'option:areCasesRequired',
          options: [{id: true, text: "原厂包装"}, {id: false, text: "混装"}],
          minWidth: '90px',
          default: true
        },
        {id: 'singleQuantity', header: '单箱数量', field: 'singleQuantity', minWidth: '90px', default: true},
        {id: 'packageQuantity', header: '箱数', field: 'packageQuantity', minWidth: '60px', default: true},
        {id: 'packageSize', header: '包装尺寸（cm）', field: 'slot:packageSize', minWidth: '120px', default: true},
        {id: 'cartonSize', header: '箱规（cm）', field: 'slot:cartonSize', minWidth: '120px', default: true},
        {id: 'totalCapacity', header: '装箱总体积（m³）', field: 'totalCapacity', minWidth: '130px', default: true},
        {
          id: 'singleProductVolumeWeight',
          header: '单品计费重（kg）',
          field: 'singleProductVolumeWeight',
          minWidth: '130px',
          default: true
        },
        {
          id: 'singleProductNetWeight',
          header: '单品净重（g）',
          field: 'singleProductNetWeight',
          minWidth: '120px',
          default: true
        },
        {id: 'packageWeight', header: '单品毛重（g）', field: 'packageWeight', minWidth: '120px', default: true},
        {
          id: 'totalProductNetWeight',
          header: '总净重（kg）',
          field: 'totalProductNetWeight',
          minWidth: '120px',
          default: true
        },
        {id: 'totalPackageWeight', header: '总毛重（kg）', field: 'totalPackageWeight', minWidth: '120px', default: true},
        {
          id: 'arriveCost',
          header: '到库成本（预估）',
          field: 'slot:arriveCost',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '120px',
          default: true
        },
        {
          id: 'purchaseCost',
          header: '采购成本（预估）',
          field: 'slot:purchaseCost',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '120px',
          default: true
        },
        {
          id: 'totalValue',
          header: '总货值(预估)',
          field: 'slot:totalValue',
          permission: 'cost:view',
          prefix: 'currencySymbol',
          minWidth: '140px',
          default: true
        },
        {
          id: 'shipPlanShipments',
          header: '货件单号|申报量',
          field: 'slot:shipPlanShipments',
          minWidth: '200px',
          default: true
        },
        {
          id: 'shipPlanTransfers',
          header: '调拨单号|调拨量',
          field: 'slot:shipPlanTransfers',
          minWidth: '200px',
          default: true
        },
        {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '120px', default: true},
        {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '155px', default: true},
        {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '180px', default: true},
      ]
    }
  },
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
  },
  created() {
    this.queryReviewOption();
  },
  methods: {
    closeOpen(val) {
      if (val === 'refresh') this.$gjQuery();
      this.purchaseVisible = false;
    },
    $gjQuery() {
      this.getShipPlanDetail(this.row.id)
    },
    /**
     * 获取发货批次详情
     * @param id
     */
    getShipPlanDetail(id) {
      if (id) {
        this.loading = true
        getShipPlanQueryDetail(id).then(res => {
          this.shipPlanDetail = Object.assign({}, this.shipPlanDetail, res)
          this.tableData = [res];
          this.tableData.forEach(item => {
            item.currencySymbol = '￥';
          })
        }).complete(() => this.loading = false)
      }
    },
    // 查询是否开启审批
    queryReviewOption() {
      queryReviewSetting({name: 'SHIP_PLAN_REVIEW_SETTING'}).then(res => {
        this.reviewOption = res;
      })
    },
    // 获取 最大 可用量
    getMaxNums(sku, warehouseId) {
      this.maxTableDataVo = {
        maxAssemblyQuantity: null,
        voList: []
      }
      this.maxLoading =  true;
      getDeliveryMaxAssemblyQuantity(sku, warehouseId).then(res => {
        if (isMeaningful(res)) this.maxTableDataVo = res;
      }).complete(()=> this.maxLoading = false)
    },
    openLog(id) {
      this.$gjCreate(GjLogModal, {
        props: {
          url: '/supply/shipPlan/get/log/page',
          params: {
            model: id
          },
          columns: [
            {id: 'createDate', header: '操作时间', field: 'createTime', minWidth: '120px'},
            {id: 'createUserName', header: '操作用户', field: 'createUserName', minWidth: '100px'},
            {
              id: 'op', header: '操作分类', field: 'option:op', options: [
                {id: 'save', text: '新增'},
                {id: 'saveArraignment', text: '新增并提审'},
                {id: 'update', text: '编辑'},
                {id: 'arraignment', text: '提审'},
                {id: 'reviewYes', text: '审核通过'},
                {id: 'reviewNo', text: '审核驳回'},
                {id: 'markComplete', text: '标记完成'},
                {id: 'delete', text: '删除'},
                {id: 'createPurchasePlan', text: '生成采购计划'},
                {id: 'createTransfer', text: '生成调拨单'},
                {id: 'createShipment', text: '创建货件'},
                {id: 'abolished', text: '作废'},
              ], minWidth: '120px'
            },
            {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '350px'}
          ],
        }
      })
    },
    // 打印标签
    printLabel() {
      let rows = this.tableData;
      this.$gjCreate(AppPrintLabelModal, {
        props: {
          ids: [],
          deliveryPlan: rows,
        },
        on: {
          created: () => {
            this.$gjResetPage();
          },
        },
      });
    },
    // 创建货件
    addPackage() {
      let rows = this.tableData;
      this.btnLoading.generateShipment = true;
      postShipPlanGenerateShipment({idList: rows.map(item => item.id)}).then(data => {
        this.$gjCreate(AddFbaShipmentModal, {
          props: {
            deliveryPlan: data,
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        });
      }).complete(() => this.btnLoading.generateShipment = false)
    },
    // 生成调拨单
    addTransferSlip() {
      let rows = this.tableData;
      this.btnLoading.generateTransfer = true;
      postShipPlanGenerateTransfer({idList: rows.map(item => item.id)}).then(res => {
        this.$gjCreate(AppOpTransferOrderModal, {
          props: {
            deliveryPlan: res,
            opType: OpEnum.type.ADD,
            header: "添加调拨单",
          },
          on: {
            created: () => {
              this.$gjResetPage();
            },
          },
        })
      }).complete(() => this.btnLoading.generateTransfer = false);
    },
    goBack() {
      this.$emit('goBack')
    },
    addPurchasePlan() {
      let rows = this.tableData;
      this.btnLoading.generatePurchasePlan = true;
      postShipPlanPurchasePlanQuery({idList: rows.map(item => item.id)}).then(res => {
        if (res && res.length > 0) {
          const modal = this.$gjCreate(OpPurchasePlanAddForDelivery, {
            props: {
              opType: 0,
              delivery: true,
              deliveryList: res,
              appendHeight: 80,
            },
            on: {
              closeOpen: (res) => {
                modal.$gjDestroy();
                if(res){
                  this.$gjResetPage();
                }
              },
            },
          });
        }
      }).complete(() => this.btnLoading.generatePurchasePlan = false)
    },
  }
}
</script>

<style scoped lang="scss">
.nav-tips {
  font-size: 12px;
  color: #999999;
  line-height: 20px;
  font-weight: 400;
}

.tips-to {
  color: #333333;
}

.content-cell {
  background: #fff;
  padding: 15px;
}

.header {
  font-size: 14px;
  color: #333333;
  line-height: 20px;
  font-weight: 600;
  padding-bottom: 15px;

  &-content {
    padding: 16px;
    background: #F7F8FA;
    font-size: 12px;
    color: #666666;
    font-weight: 400;

    &__item {
      display: inline-block;
      width: 15%;
      margin-right: 40px;

      .label {
        color: #666;
      }

      .value {
        color: #333;
      }
    }
  }
}

.table-footer {
  text-align: right;
  height: 38px;
  line-height: 38px;
  background: #F6F8FB;
  font-size: 12px;
  color: #333333;
  font-weight: 600;
  padding-right: 20px;
}

/deep/ .gj-dialog-plan {
  .purchase-plan {
    padding: 0;
    // margin-top: -50px !important;
  }
}
.base-text{
  color: #999999;
  font-size: 12px;
}
.icon-back{
  color: #999999;
  font-size: 12px;
  cursor: pointer;
}
.icon-back:hover{
  color: #5d9bfc;
}
.header-content_group{
  padding: 12px 12px 0 12px;
  background: #F7F8FA;
  .header-content{
    padding: 0 0 12px 0;
  }
}
/deep/ .operate-group{
  margin: 0;
}
/deep/ .content-cell{
  padding-top: 10px;
  padding-bottom: 0;
}
/deep/ .gj-area-title{
  margin-bottom: 12px;
}


</style>
